import AddIcon from '@mui/icons-material/Add';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import {
  Box,
  Button,
  Card,
  Chip,
  Divider,
  FormControlLabel,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { paths } from 'src/paths';
import {
  editAuthorizationAction,
  editAuthorizationResetAction,
  getCptCodeByDisciplineAction,
} from 'src/redux/actions/therapyPlanning';
import * as Yup from 'yup';
import SimpleSnackbar from 'src/pages/details-page/sub-components/snackBar';

const { therapyPlanning } = paths;

const discipline = ['PT', 'OT', 'SLP', 'OT, PT , SLP'];
const levelTableHeading = ['Level', 'Disciplines', 'Frequency', 'Minimum number of minutes'];

const validationWithPayerManagedByLevel = Yup.object().shape({
  number: Yup.string(),
  additionalInfo: Yup.mixed(),
  startDate: Yup.date().required('Please enter a valid Start Date'),
  endDate: Yup.mixed(),
});

const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.7 6.6V5.88C14.7 4.87191 14.7 4.36786 14.5038 3.98282C14.3312 3.64413 14.0559 3.36876 13.7172 3.19619C13.3321 3 12.8281 3 11.82 3H10.38C9.37191 3 8.86786 3 8.48282 3.19619C8.14413 3.36876 7.86876 3.64413 7.69619 3.98282C7.5 4.36786 7.5 4.87191 7.5 5.88V6.6M3 6.6H19.2M17.4 6.6V16.68C17.4 18.1921 17.4 18.9482 17.1057 19.5258C16.8469 20.0338 16.4338 20.4469 15.9258 20.7057C15.3482 21 14.5921 21 13.08 21H9.12C7.60786 21 6.85179 21 6.27423 20.7057C5.76619 20.4469 5.35314 20.0338 5.09428 19.5258C4.8 18.9482 4.8 18.1921 4.8 16.68V6.6"
        stroke="#6C737F"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const AuthorizationEditDetails = () => {
  const [isDisciplineDropdownOpen, setIsDisciplineDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const selectedPatient = state?.selectedPatient;

  const patientInfo = useSelector((state: any) => state?.selectPatientReducer?.patientInfo);
  const getAllCPTcodes = useSelector((state: any) => state.getCptCodeByDisciplineReducer);
  const isEditedAuth = useSelector((state: any) => state.editAuthorizationReducer);
  const authDetails = useSelector(
    (state: any) => state.getAuthorizationDetailsReducer?.response?.data
  );

  const disciplineData = [
    {
      id: '0',
      selected_discipline: '',
      ptDiscipline: false,
      otDiscipline: false,
      slpDiscipline: false,
      discipleMenuList: discipline,
      approved_CPT_codes_List: [],
      selected_approved_cpt_codes: [],
      noOfUnits: false,
      noOfVisits: false,
      quantity: 0,
      errorInChooseMethod: false,
      errorInQuantity: false,
    },
  ];

  const [disciplineList, setDisciplineList] = useState(disciplineData);
  const [selectedLevel, setSelectedLevel] = useState<any>(null);
  const [selectedDisciple, setSelectedDisciple] = useState<any>([]);

  const selectedDiscipleFun = (ot: boolean, pt: boolean, slp: boolean) => {
    if (pt && ot && slp) {
      return 'OT, PT , SLP';
    }
    if (ot) {
      return 'OT';
    }
    if (pt) {
      return 'PT';
    }
    if (slp) {
      return 'SLP';
    }
  };

  useEffect(() => {
    if (!!authDetails?.authDisciplineDTOList?.length && !!getAllCPTcodes?.response) {
      let arrayOfDiscipline: any = [];
      const getUpdatedDisciplineData = authDetails?.authDisciplineDTOList?.map(
        (des: any, index: any) => {
          const getSelectedDes = selectedDiscipleFun(
            des?.otDiscipline,
            des?.ptDiscipline,
            des?.slpDiscipline
          );

          arrayOfDiscipline.push(getSelectedDes);

          return {
            id: index,
            selected_discipline: getSelectedDes,
            ptDiscipline: des?.ptDiscipline,
            otDiscipline: des?.otDiscipline,
            slpDiscipline: des?.slpDiscipline,
            discipleMenuList: discipline,
            approved_CPT_codes_List:
              getAllCPTcodes?.response?.data[getDiscipleName(getSelectedDes)],
            selected_approved_cpt_codes: des?.cptCodes,
            noOfUnits: des?.noOfUnits,
            noOfVisits: des?.noOfVisits,
            quantity: des?.quantity,
            errorInChooseMethod: false,
            errorInQuantity: false,
          };
        }
      );

      setDisciplineList(getUpdatedDisciplineData);
      setSelectedDisciple(arrayOfDiscipline);
    }
  }, [authDetails, getAllCPTcodes]);

  useEffect(() => {
    if (!!authDetails?.authLevelDTO) {
      const selectedObj = {
        id:
          authDetails?.authLevelDTO?.level == 'level 1'
            ? '1'
            : authDetails?.authLevelDTO?.level == 'level 2'
            ? '2'
            : authDetails?.authLevelDTO?.level == 'level 3'
            ? '3'
            : authDetails?.authLevelDTO?.level == 'level 4'
            ? '4'
            : '5',
        ...authDetails?.authLevelDTO,
      };

      const [selectetPayerLevel] = selectedPatient?.levels?.filter(
        (item: any) => item?.level === selectedObj?.level
      );

      const newSelectedObj = {
        frequency: selectetPayerLevel?.frequency || selectedObj?.frequency,
        id: selectedObj?.id,
        level: selectetPayerLevel?.level || selectedObj?.level,
        noOfMinutes: selectetPayerLevel?.minMinutePerWeek || selectedObj?.noOfMinutes,
        otDiscipline: selectetPayerLevel?.otDiscipline || selectedObj?.otDiscipline,
        ptDiscipline: selectetPayerLevel?.ptDiscipline || selectedObj?.ptDiscipline,
        slpDiscipline: selectetPayerLevel?.slpDiscipline || selectedObj?.slpDiscipline,
        uuid: selectetPayerLevel?.uuid || selectedObj?.uuid,
      };

      setSelectedLevel(newSelectedObj);
    }
  }, [authDetails]);

  const [currentDisciple, setCurrentDisciple] = useState<any>('');

  const [error, setError] = useState('');

  useEffect(() => {
    if (isEditedAuth?.isEditAuth === false && isEditedAuth?.response === null) return;
    else if (isEditedAuth?.isEditAuth === false && isEditedAuth?.response !== null) {
      setError(isEditedAuth?.response?.message || isEditedAuth?.response?.title);
      setTimeout(() => {
        dispatch(editAuthorizationResetAction());
      }, 5000);
    } else {
      setError(isEditedAuth?.response?.message);
      setTimeout(() => {
        dispatch(editAuthorizationResetAction());
        navigate(
          `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.authorization}`,
          {
            state: {
              patientId: selectedPatient?.uuid,
            },
          }
        );
      }, 3000);
    }
  }, [isEditedAuth]);

  const handleRadioChange = (level: any) => {
    setSelectedLevel({ ...level, noOfMinutes: level?.minMinutePerWeek });
    setErrorWhileAuth(false);
  };

  useEffect(() => {
    if (!!patientInfo?.uuid) {
      dispatch(
        getCptCodeByDisciplineAction({
          patientId: patientInfo?.uuid,
        })
      );
    }
  }, []);

  const handleAddAnotherDisciple = () => {
    const isAlreadyExist = selectedDisciple.find((res: any) => res === currentDisciple);
    if (isAlreadyExist) {
      return;
    }
    const getListData = disciplineList?.find(
      (list: any) => list?.selected_discipline === currentDisciple
    );
    const getFilterList = getListData?.discipleMenuList?.filter(
      (res: any) => res !== currentDisciple
    );

    const newObj = {
      id:
        selectedDisciple?.length == '0'
          ? '1'
          : selectedDisciple?.length == '1'
          ? '2'
          : selectedDisciple?.length == '2'
          ? '3'
          : '4',
      to_discipline: '',
      selected_discipline: '',
      discipleMenuList: getFilterList,
      approved_CPT_codes_List: [],
      errorInChooseMethod: false,
      errorInQuantity: false,
      selected_CPT_code: '',
      selected_approved_cpt_codes: [],
      choose_method: '',
      add_quantity: '',
    };

    setDisciplineList((prev: any) => [...prev, newObj]);
    setSelectedDisciple((prev: any) => [...prev, currentDisciple]);
  };

  const getDiscipleName = (name: any) => {
    return name === 'SLP' ? 'SLP' : name === 'PT' ? 'PT' : name === 'OT' ? 'OT' : 'all';
  };

  const handleClickDisciplineDropdown = (e: any, disc: any) => {
    if (e?.target?.innerText === '') {
      return;
    }

    const getCPT = getAllCPTcodes?.response?.data[getDiscipleName(e?.target?.innerText)] || [];

    setDisciplineList((prevEvents: any) => {
      return prevEvents?.map((event: any) => {
        if (event?.id === disc?.id) {
          return {
            ...event,
            selected_discipline: e?.target?.innerText,
            approved_CPT_codes_List: getCPT,
            slpDiscipline:
              e?.target?.innerText === 'SLP' || e?.target?.innerText === 'OT, PT , SLP'
                ? true
                : false,
            ptDiscipline:
              e?.target?.innerText === 'PT' || e?.target?.innerText === 'OT, PT , SLP'
                ? true
                : false,
            otDiscipline:
              e?.target?.innerText === 'OT' || e?.target?.innerText === 'OT, PT , SLP'
                ? true
                : false,
          };
        }
        return event;
      });
    });
    return setCurrentDisciple(e?.target?.innerText);
  };

  const [errorWhileAuth, setErrorWhileAuth] = useState(false);

  const formik = useFormik({
    initialValues: {
      number: authDetails?.number ? authDetails?.number : '',
      additionalInfo: authDetails?.additionalInfo ? authDetails?.additionalInfo : '',
      startDate: authDetails?.startDate ? new Date(authDetails?.startDate) : '',
      endDate: authDetails?.endDate ? new Date(authDetails?.endDate) : '',
    },
    validationSchema: validationWithPayerManagedByLevel,
    onSubmit: (values) => {
      if (selectedPatient?.payerManageLevel) {
        if (!selectedLevel) {
          return setErrorWhileAuth(true);
        }
        const payerManageObj = {
          level: selectedLevel?.level,
          ptDiscipline: selectedLevel?.ptDiscipline,
          otDiscipline: selectedLevel?.otDiscipline,
          slpDiscipline: selectedLevel?.slpDiscipline,
          frequency: selectedLevel?.frequency,
          noOfMinutes: selectedLevel?.noOfMinutes,
          minutesType: selectedLevel?.minutesType,
        };
        dispatch(
          editAuthorizationAction({
            patientId: selectedPatient?.uuid,
            number: values?.number,
            startDate: values?.startDate ? new Date(values?.startDate)?.toISOString() : null,
            endDate: values?.endDate ? new Date(values?.endDate)?.toISOString() : null,
            additionalInfo: values?.additionalInfo,
            authLevelDTO: !!selectedLevel ? payerManageObj : null,
          })
        );
        return;
      } else {
        const updatedState = disciplineList?.map((item: any) => ({
          ...item,
          errorInChooseMethod: !(item?.noOfUnits || item?.noOfVisits),
          errorInQuantity: !item?.quantity,
        }));
        setDisciplineList(updatedState);
        const allErrorsAreFalse = updatedState?.every(
          (item) => item?.errorInChooseMethod === false && item?.errorInQuantity === false
        );

        if (!allErrorsAreFalse) {
          return;
        }

        const newBodyObj = disciplineList
          ?.filter?.((dis) => dis?.selected_discipline !== '')
          ?.map((dis) => {
            return {
              ptDiscipline: dis?.ptDiscipline,
              slpDiscipline: dis?.slpDiscipline,
              otDiscipline: dis?.otDiscipline,
              cptCodes: dis?.selected_approved_cpt_codes,
              noOfVisits: dis?.noOfVisits ? dis?.noOfVisits : false,
              noOfUnits: dis?.noOfUnits ? dis?.noOfUnits : false,
              quantity: dis?.quantity ? dis?.quantity : '0',
            };
          });

        dispatch(
          editAuthorizationAction({
            patientId: selectedPatient?.uuid,
            number: values?.number,
            startDate: values?.startDate ? new Date(values?.startDate)?.toISOString() : null,
            endDate: values?.endDate ? new Date(values?.endDate)?.toISOString() : null,
            additionalInfo: values?.additionalInfo,
            authDisciplineDTOList: newBodyObj,
          })
        );
        return;
      }
    },
  });

  const handleCptCode = (event: SelectChangeEvent<any>, item: any) => {
    const {
      target: { value },
    } = event;

    if (value?.length == 0 || value[0] == 'val' || value?.includes('')) return;
    setDisciplineList((prevEvents: any) => {
      return prevEvents?.map((event: any) => {
        if (event?.id === item?.id) {
          return {
            ...event,
            selected_approved_cpt_codes: typeof value === 'string' ? value.split(',') : value,
          };
        }
        return event;
      });
    });
  };

  const handleNumberOfUnitBilled = (e: any, item: any) => {
    setDisciplineList((prevEvents: any) => {
      return prevEvents?.map((event: any) => {
        if (event?.id === item?.id) {
          return {
            ...event,
            noOfUnits: e.target.value === 'NUMBER_UNIT_BILLED' ? true : false,
            noOfVisits: e.target.value === 'NUMBER_OF_VISIT' ? true : false,
          };
        }
        return event;
      });
    });
  };

  const handleAddQuantity = (e: any, item: any) => {
    const numericRegex = /^[0-9]*$/;
    const inputValue = e?.target?.value;

    if (numericRegex?.test(inputValue)) {
      setDisciplineList((prevEvents: any) => {
        return prevEvents?.map((event: any) => {
          if (event?.id === item?.id) {
            return {
              ...event,
              quantity: e?.target?.value,
            };
          }
          return event;
        });
      });
    }
  };

  const handleDeleteChips = (event: any, value: any, item: any) => {
    event.stopPropagation();

    const findItem = disciplineList?.find((res: any) => res?.id === item?.id);
    if (!findItem) {
      return;
    }
    setDisciplineList((prevEvents: any) => {
      return prevEvents?.map((event: any) => {
        if (event?.id === item?.id) {
          return {
            ...event,
            selected_approved_cpt_codes: findItem?.selected_approved_cpt_codes?.filter(
              (res) => res !== value
            ),
          };
        }
        return event;
      });
    });
  };

  const handleDeleteDecline = (item: any) => {
    setSelectedDisciple(selectedDisciple?.filter((res: any) => res !== item?.selected_discipline));
    setDisciplineList(disciplineList?.filter((res) => res?.id !== item?.id));
  };

  const remainingDisciplines = discipline?.filter((disc) => !selectedDisciple?.includes(disc));

  return (
    <Stack
      sx={{
        maxWidth: {
          sm: '700px',
          md: '800px',
          lg: '950px',
          xl: '1250px',
        },
        width: '100%',
        margin: '0 auto',
        marginTop: '2rem',
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <Stack gap="1.5rem">
          <Stack
            flexDirection="row"
            gap=".5rem"
            alignItems="center"
          >
            <IconButton
              onClick={() =>
                navigate(
                  `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.authorization}`,
                  {
                    state: {
                      patientId: selectedPatient?.uuid,
                    },
                  }
                )
              }
              sx={{ margin: '0', padding: '0' }}
            >
              <ArrowBackOutlinedIcon fontSize="small" />
            </IconButton>
            <Typography
              sx={{ color: '#6C737F', cursor: 'pointer' }}
              variant="subtitle2"
              onClick={() =>
                navigate(
                  `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.authorization}`,
                  {
                    state: {
                      patientId: selectedPatient?.uuid,
                    },
                  }
                )
              }
            >
              Back to Authorization
            </Typography>
          </Stack>
          <Typography
            sx={{ fontSize: '28px !important' }}
            variant="h4"
          >
            Edit Authorization Information
          </Typography>
        </Stack>
        <Stack>
          <Card>
            <Stack
              gap="1.5rem"
              sx={{ padding: '1.5rem' }}
            >
              <Typography variant="h6">General Information</Typography>
              <Stack
                gap="1.5rem"
                flexDirection="row"
              >
                <Box flex={3}>
                  {/* <TextField
                    fullWidth
                    label="Authorization number"
                  /> */}
                  <TextField
                    error={!!(formik.touched.number && formik.errors.number)}
                    fullWidth
                    helperText={formik.touched.number && (formik.errors.number as any)}
                    label="Authorization number"
                    name="number"
                    onBlur={formik.handleBlur}
                    onChange={(e) => {
                      const trimmedValue = e.target.value.trim();
                      formik.setFieldValue('number', trimmedValue);
                    }}
                    value={formik.values.number}
                  />
                </Box>
                <Box flex={3}>
                  <DatePicker
                    onChange={(newDate) => formik.setFieldValue('startDate', newDate)}
                    value={!!formik.values.startDate ? formik.values.startDate : null}
                    format="MMM dd, yyyy"
                    sx={{
                      width: '100%',
                      border:
                        formik.touched.startDate && formik.errors.startDate
                          ? '2px solid red'
                          : 'cyan',
                      borderRadius:
                        formik.touched.startDate && formik.errors.startDate ? '10px' : '',
                    }}
                    label="Start Date"
                  />
                  {formik.touched.startDate && formik.errors.startDate && (
                    <Typography
                      padding={'0px 20px'}
                      color={'red'}
                      variant="caption"
                    >
                      {formik?.errors?.startDate}
                    </Typography>
                  )}
                </Box>
                <Box flex={3}>
                  <DatePicker
                    onChange={(newDate) => {
                      if (!newDate) {
                        return formik.setFieldValue('endDate', '');
                      }
                      formik.setFieldValue('endDate', newDate);
                    }}
                    label="End Date"
                    value={!!formik.values.endDate ? formik.values.endDate : null}
                    minDate={new Date(formik.values.startDate)}
                    format="MMM dd, yyyy"
                    sx={{
                      width: '100%',
                      border:
                        !!formik.touched.endDate && !!formik.errors.endDate
                          ? '2px solid red'
                          : 'none',
                      borderRadius: formik.touched.endDate && formik.errors.endDate ? '10px' : '',
                    }}
                  />
                  {formik.touched?.endDate && formik.errors?.endDate && (
                    <Typography
                      padding={'0px 16px'}
                      color={'red'}
                      variant="caption"
                    >
                      {formik?.errors?.endDate}
                    </Typography>
                  )}
                </Box>
              </Stack>
            </Stack>
          </Card>
          <Card>
            {selectedPatient?.payerManageLevel ? (
              <Stack
                gap=".5rem"
                sx={{ padding: '1rem 1.5rem', width: '100%' }}
              >
                <Typography variant="h6">Authorization by Levels</Typography>
                <Typography
                  sx={{ color: '#9E9E9E' }}
                  variant="caption"
                >
                  Choose Level
                </Typography>
                <Stack
                  flexDirection="row"
                  gap="1rem"
                >
                  <Stack
                    gap=".25rem"
                    flex={5}
                    py={2}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          {levelTableHeading?.map((levels: string) => (
                            <TableCell key={levels}>{levels}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectedPatient?.levels
                          ?.sort((a: any, b: any) => {
                            if (a?.level < b?.level) {
                              return -1;
                            }
                            if (a?.level > b?.level) {
                              return 1;
                            }
                            return 0;
                          })
                          ?.map((level_info: any) => (
                            <TableRow key={level_info?.id}>
                              <TableCell>
                                <RadioGroup
                                  value={
                                    selectedLevel?.level == level_info?.level ? 'PAYER_MANAGE' : ''
                                  }
                                >
                                  <FormControlLabel
                                    value={'PAYER_MANAGE'}
                                    control={
                                      <Radio onChange={() => handleRadioChange(level_info)} />
                                    }
                                    label={level_info?.level}
                                  />
                                </RadioGroup>
                              </TableCell>
                              <TableCell>
                                {[
                                  level_info.otDiscipline && 'OT',
                                  level_info.ptDiscipline && 'PT',
                                  level_info.slpDiscipline && 'SLP',
                                ]
                                  ?.filter(Boolean)
                                  ?.join(', ') || '-'}
                              </TableCell>
                              <TableCell>
                                {level_info?.frequency ? level_info?.frequency : '0'} / Week
                              </TableCell>
                              <TableCell>{`${level_info?.minMinutePerWeek} / ${
                                level_info?.minutesType || 'Week'
                              } `}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                    {errorWhileAuth && (
                      <Typography
                        padding={'0px 20px'}
                        sx={{
                          marginTop: '10px',
                        }}
                        color={'red'}
                        variant="caption"
                      >
                        {'*Please select the Level'}
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              </Stack>
            ) : (
              <Stack
                gap=".5rem"
                sx={{ padding: '1rem 1.5rem', width: '100%' }}
              >
                <Typography variant="h6">Authorization by Discipline</Typography>

                {/* add multiple list */}

                {disciplineList?.map((disc: any, index: any) => {
                  return (
                    <Box key={index}>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography
                          sx={{ mt: 2, mb: 2 }}
                          variant="subtitle2"
                        >
                          Discipline {+index + 1}
                        </Typography>
                        {/* {+disc?.id === 0 ? null : ( */}
                        <IconButton onClick={() => handleDeleteDecline(disc)}>
                          <DeleteIcon />
                        </IconButton>
                        {/* )} */}
                      </Box>
                      <Stack
                        flexDirection="row"
                        gap="1rem"
                      >
                        <Stack
                          gap=".25rem"
                          flex={5}
                        >
                          <Typography
                            sx={{ color: '#9E9E9E' }}
                            variant="caption"
                          >
                            Discipline
                          </Typography>

                          <Select
                            value={disc?.selected_discipline ? disc?.selected_discipline : ''}
                            fullWidth
                            displayEmpty
                            onClick={(e) => handleClickDisciplineDropdown(e, disc)}
                            renderValue={(value) => {
                              if (value === '')
                                return (
                                  <Typography
                                    sx={{ color: '#6C737F' }}
                                    variant="subtitle2"
                                  >
                                    {isDisciplineDropdownOpen
                                      ? 'Add Approved CPT codes'
                                      : 'Choose Discipline'}
                                  </Typography>
                                );
                              else return <div>{value as any}</div>;
                            }}
                          >
                            {/* {remainingDisciplines?.length === 0 && (
                                <MenuItem
                                  value="val"
                                  sx={{ pointerEvents: 'none' }}
                                >
                                  All disciples are selected
                                </MenuItem>
                              )} */}
                            {remainingDisciplines?.map((dips: string) => (
                              <MenuItem
                                key={dips}
                                value={dips}
                              >
                                {dips}
                              </MenuItem>
                            ))}
                          </Select>
                        </Stack>
                        <Stack
                          gap=".25rem"
                          flex={5}
                        >
                          <Typography
                            sx={{ color: '#9E9E9E' }}
                            variant="caption"
                          >
                            Approved CPT codes
                          </Typography>
                          <Select
                            defaultValue=""
                            displayEmpty
                            fullWidth
                            multiple
                            onChange={(e) => handleCptCode(e, disc)}
                            value={disc?.selected_approved_cpt_codes || []}
                            renderValue={(selected) => {
                              if (selected?.length == 0) {
                                return (
                                  <Typography
                                    sx={{ color: '#6C737F' }}
                                    variant="subtitle2"
                                  >
                                    Choose Discipline
                                  </Typography>
                                );
                              }

                              return (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                  {selected?.map((value: any) => (
                                    <Chip
                                      key={value}
                                      label={value}
                                      variant="outlined"
                                      onMouseDown={(event) => event.stopPropagation()}
                                      onDelete={(event) => handleDeleteChips(event, value, disc)}
                                    />
                                  ))}
                                </Box>
                              );
                            }}
                          >
                            {disc?.approved_CPT_codes_List?.length === 0 && (
                              <MenuItem value="val">
                                No CPT code available for this disciple
                              </MenuItem>
                            )}
                            {disc?.approved_CPT_codes_List?.map((dips: any) => (
                              <MenuItem
                                key={dips}
                                value={dips}
                              >
                                {dips}
                              </MenuItem>
                            ))}
                          </Select>
                        </Stack>
                      </Stack>
                      <Typography
                        sx={{ color: '#6C737F' }}
                        variant="subtitle2"
                        mt={2}
                      >
                        {' '}
                        Choose method
                      </Typography>
                      <Stack
                        gap="4rem"
                        flexDirection="row"
                        my={2}
                      >
                        <Stack flexDirection="column">
                          <Box>
                            <RadioGroup
                              onChange={(e) => handleNumberOfUnitBilled(e, disc)}
                              sx={{ display: 'flex', flexDirection: 'row' }}
                              value={
                                disc?.noOfUnits
                                  ? 'NUMBER_UNIT_BILLED'
                                  : disc?.noOfVisits
                                  ? 'NUMBER_OF_VISIT'
                                  : ''
                              }
                            >
                              <FormControlLabel
                                value={'NUMBER_UNIT_BILLED'}
                                control={<Radio />}
                                label="Number of unit billed"
                              />
                              <FormControlLabel
                                value={'NUMBER_OF_VISIT'}
                                control={<Radio />}
                                label="Number of visit"
                              />
                            </RadioGroup>
                          </Box>
                          {disc?.errorInChooseMethod && (
                            <Typography
                              padding={'20px 0px'}
                              color={'red'}
                              variant="caption"
                            >
                              {'Please Select a method '}
                            </Typography>
                          )}
                        </Stack>

                        <Stack flexDirection="column">
                          <TextField
                            sx={{ width: '100px' }}
                            value={disc?.quantity ? disc?.quantity : ''}
                            label="Add Qty."
                            onChange={(e) => handleAddQuantity(e, disc)}
                          />
                          {disc?.errorInQuantity && (
                            <Typography
                              padding={'5px 0px'}
                              color={'red'}
                              variant="caption"
                            >
                              {'Please enter a valid quantity '}
                            </Typography>
                          )}
                        </Stack>
                      </Stack>

                      <Divider sx={{ borderColor: '#E5E7EB' }} />
                    </Box>
                  );
                })}

                {disciplineList?.length < 4 ? (
                  <Stack
                    sx={{ padding: '0 .25rem' }}
                    my={2}
                  >
                    <Button
                      sx={{ maxWidth: 'max-content' }}
                      startIcon={<AddIcon />}
                      onClick={() => handleAddAnotherDisciple()}
                    >
                      Add another discipline
                    </Button>
                  </Stack>
                ) : null}
                <Divider sx={{ borderColor: '#E5E7EB' }} />
              </Stack>
            )}

            <Stack
              gap=".5rem"
              sx={{ padding: '1.5rem' }}
            >
              <Typography
                sx={{ color: '#111927' }}
                variant="subtitle2"
              >
                Additional Info
              </Typography>

              <TextField
                error={!!(formik.touched.additionalInfo && formik.errors.additionalInfo)}
                fullWidth
                helperText={
                  String(formik?.touched?.additionalInfo) && (formik?.errors?.additionalInfo as any)
                }
                multiline
                rows={4}
                name="additionalInfo"
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  formik.setFieldValue('additionalInfo', e.target.value);
                }}
                value={formik.values.additionalInfo}
                placeholder="Add Text..."
              />
            </Stack>
          </Card>
        </Stack>
        <Stack
          alignItems="center"
          sx={{ marginTop: '1.5rem' }}
          flexDirection="row"
          justifyContent="flex-end"
          gap=".5rem"
        >
          <Button
            onClick={() =>
              navigate(
                `${therapyPlanning.index}${therapyPlanning.details}${therapyPlanning.authorization}`,
                {
                  state: {
                    patientId: selectedPatient?.uuid,
                  },
                }
              )
            }
            color="inherit"
          >
            Cancel
          </Button>
          <Button
            sx={{ height: '40px', padding: '4px 12px' }}
            color="primary"
            variant="contained"
            disabled={isEditedAuth?.loading}
            type="submit"
          >
            Save changes
          </Button>
        </Stack>
      </form>
      {(isEditedAuth?.response !== null || isEditedAuth?.response !== null) && (
        <SimpleSnackbar
          message={error}
          isError={!isEditedAuth?.isEditAuth && isEditedAuth?.isEditAuth !== null}
        />
      )}
    </Stack>
  );
};

export default AuthorizationEditDetails;
